import React from 'react';

export default class Alphabet extends React.Component {

  constructor() {
    super(); 
    this.state = {
      letter: '',
      active: ''
    }
  }

  handleAlphaClick = (e) => {
    e.preventDefault();
    this.setState(
      { [e.target.name]: e.target.innerText }, 
      () => {
        if (this.props.onChange) {
          this.props.onChange(this.state);
        }
      });
    
  }

  render() {
    return (        
      <a
        href="/"
        id={this.props.items.id}   
        name="letter" 
        data={this.props.fields.Alphabet.value}
        onClick={this.handleAlphaClick.bind(this)}
        className={this.props.clsName}
        >
          {this.props.fields.Alphabet.value}
      </a>
    )
  }
}
